import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { type FirestoreProfileType } from '@/defs/firestore'

type UserStateType =
  | {
      profile: null
      status: 'signedOut'
    }
  | {
      profile: null
      status: 'loading'
    }
  | {
      profile: FirestoreProfileType
      status: 'signedIn'
    }

const initialState: UserStateType = {
  profile: null,
  status: 'loading',
}

export const userSlice = createSlice({
  initialState: initialState as UserStateType,
  name: 'user',
  reducers: {
    authLoading: (s) => {
      s.status = 'loading'
      s.profile = null
    },
    authSignIn: (s, action: PayloadAction<FirestoreProfileType>) => {
      s.status = 'signedIn'
      s.profile = action.payload
    },
    authSignOut: (s) => {
      s.profile = null
      s.status = 'signedOut'
    },
    update: (state, action: PayloadAction<FirestoreProfileType>) => {
      if (state.status === 'signedIn') state.profile = action.payload
    },
  },
})

export const userActions = userSlice.actions
export const userReducer = userSlice.reducer
